import { render } from "./PerDiemManagement.vue?vue&type=template&id=4d5c2018"
import script from "./PerDiemManagement.vue?vue&type=script&lang=js"
export * from "./PerDiemManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__